module.exports = __webpack_public_path__ + "img/determine.cb22c1c6.png";